import React, { Component } from "react";

export default class ApiIntegration extends Component {
    constructor(props) {
      super(props);
      this.state = {
        error: null,
        isLoaded: false,
        items: []
      };
    }
  
    componentDidMount() {
      const API_BASE = (window._env_ && window._env_.REACT_APP_API_URL) || process.env.REACT_APP_API_URL || '';
      const API_KEY = (window._env_ && window._env_.REACT_APP_API_KEY) || process.env.REACT_APP_API_KEY || '';
      const base = API_BASE.replace(/\/$/, '');
      const url = base ? `${base}/employees` : '/employees';
      
      const headers = {
        'Content-Type': 'application/json'
      };
      if (API_KEY) {
        headers['X-API-Key'] = API_KEY;
      }

      fetch(url, { headers })
        .then(res => res.json())
        .then(
          (result) => {
            this.setState({
              isLoaded: true,
              items: result
            });
            console.log(result);
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            this.setState({
              isLoaded: true,
              error
            });
          }
        )
    }
  
    render() {
      const { error, isLoaded, items } = this.state;
      console.log(items)
      if (error) {
        return <div>Error: {error.message}</div>;
      } else if (!isLoaded) {
        return <div>Loading...</div>;
      } else {
        return (
          <ul>
            {items.map(item => (
              <li key={item.id}>
                {item.firstName} {item.lastName}
              </li>
            ))}
          </ul>
        );
      }
    }
  }